<template>
    <div :class="{ 'widget-cards-buffer-wrapper': true, 'collapsed': collapsed }">

        <div class="widget-cards-buffer">

            <v-btn v-show="widgetItemsAny & collapsed" class="show-button"
                   fab
                   dark
                   color="primary"
                   @click="fnShow">
                <v-icon dark>
                    mdi-bell
                </v-icon>
            </v-btn>
            <transition-group name="slide" tag="div">
                <widget-card v-for="(item, index) in widgetItems" :key="item.properties.dynamicId" class="wcard">
                    <template>
                        <component :is="item.component" v-bind="item.properties"></component>
                    </template>
                </widget-card>
            </transition-group>

        </div>
        <div class="button-wrapper">
            <v-btn v-show="widgetItemsAny & !collapsed" color="secondary" @click="fnHide" class="hide-button"> > > > </v-btn>

        </div>
    </div>
</template>

<script>
    import WidgetCard from '@/shared/components/home/WidgetCard.vue';
    import ExportationModal from '@/shared/components/common/Exportation/ExportationModal.vue';
    import ExcelAutoExportationModal from '@/shared/components/common/Exportation/ExcelAutoExportationModal.vue';
    import TwoStepsDownloaderModal from '@/shared/components/common/Exportation/TwoStepsDownloaderModal.vue';
    export default {
        name: "WidgetCardsBuffer",
        components: { WidgetCard, ExportationModal, ExcelAutoExportationModal, TwoStepsDownloaderModal},
        created() {

        },
        data() {
            return {
            };
        },
        props: {

        },
        methods: {
            fnShow() {
                this.$store.dispatch("openWidgetCardsBuffer");
            },
            fnHide() {
                this.$store.dispatch("collapseWidgetCardsBuffer");
            },
            fnPush(item) {
                this.$store.dispatch("insertWidgetCard", item);
            },
            fnRemove(itemKey) {
                this.$store.dispatch("removeWidgetCard", itemKey);
            }
        },
        computed: {
            widgetItems: function () {
                return this.$store.getters.widgetItems;
            },
            widgetItemsAny: function () {
                return this.$store.getters.widgetItemsCount > 0;
            },
            collapsed: function () {
                return this.$store.getters.widgetItemsCollapsed
            }
        },
    };
</script>

<style scoped>
    .widget-cards-buffer-wrapper {
        width: 0px;
        overflow: visible;
        height: calc(100% - 40px);
        background-color: rgb(0,0,0,0);
        position: absolute;
        right: 7px;
        justify-content: flex-start;
        align-items: center;
        margin-right: 5px;
        transition: 0.5s;
    }

    .widget-cards-buffer {
        width: 350px;
        max-height: calc(100% - 50px);
        display: flex;
        flex-direction: column-reverse;
        position: absolute;
        justify-content: flex-start;
        align-items: center;
        overflow-y: scroll;
        overflow-x: hidden;
        right: 0px;
        z-index: 1051;
        bottom: 45px;
    }

    .hide-button {
        width: 100%;
        z-index: 1020;
        height: 20px !important
    }
    .show-button {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 1020
    }


    .button-wrapper {
        width: 340px;
        height: 40px;
        bottom: 0px;
        position: absolute;
        right: 6px;
        z-index: 1051;
    }

    .collapsed {
        right: -342px
    }

        .widget-cards-buffer::-webkit-scrollbar-track {
            width: 5px
        }

        .widget-cards-buffer::-webkit-scrollbar {
            width: 5px;
            background-color: transparent;
        }

        .widget-cards-buffer::-webkit-scrollbar-thumb {
            border-radius: 20px;
            width: 0px;
            background-color: var(--jll-dark-red-08);
            cursor: pointer;
        }

            .widget-cards-buffer::-webkit-scrollbar-thumb:hover {
                background-color: var(--jll-dark-red-08);
            }

        .widget-cards-buffer::-webkit-scrollbar-track:hover {
            -webkit-box-shadow: inset 0.3px 0 2px rgba(0, 0, 0, 0.2);
            border-radius: 20px;
        }

    
    .slide-enter-active {
        transition: opacity 0.3s, transform 0.3s, max-height 0.15s ease-out;
    }

    .slide-leave-active {
        transition: opacity 0s, transform 0s, max-height 0s ease-out;
    }
    .slide-enter {
        transform: scaleY(0);
        transform: scaleX(0);
        opacity: 0;
    }

    .slide-leave {

    }


    .slide-move {
        transition: transform 0.3s;
    }

   .slide-leave-to {
        transform: scaleY(0);
        transform: scaleX(0);
        max-height: 0px;
        opacity: 0;
    }
</style>

